<template>
  <div class="l-sub-banner">
    <div class="msg _container">
            <h1 class="title">
                {{ title }}
            </h1>
            <h4 class="sub-title">
                {{ subTitle }}
            </h4>
            <p class="slogan">
                {{ slogan }}
            </p>
        </div>
    <l-img :src='src'/>
  </div>
</template>

<script>
export default {
  name: 'l-sub-banner',
  props: {
    src:{
      default: ''
    },
    title: {
      default: ''
    },
    subTitle: {
      default: ''
    },
    slogan:{
      default: ''
    }
  },
}
</script>
<style lang="scss" scoped>
.l-sub-banner{
  position: relative;
  height: 600px;
}

.msg{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  margin: auto;
  height: 248px;
  z-index: 9;
  color: $font_color_light;

    .title{
        margin-bottom: 22px;
        font-size: $font_size_banner_title;
    }
    
    .sub-title{
        font-weight: 300;
        font-size: $font_size_banner_sub_title;
    }

    .slogan{
        margin-top: 102px;
        font-size: $font_size_banner_slogan;
        font-weight: 300;
    }
    
}

</style>